import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import nagpurBanner from '../../assets/images/city-banners/nagpur.png';

const CitiesPage: React.FC = () => {
  const cities = [
    {
      name: "Nagpur",
      description: "The Orange City with CTRL+P services across major educational institutions.",
      image: nagpurBanner,
      link: "/cities/nagpur"
    },
    // Add Other cities here
  ];

  return (
    <>
      <Header />
      <div className="bg-gray-50">
        <div className="container mx-auto px-4 py-16">
          <h1 className="text-5xl font-bold mb-2 text-center text-gray-800">CTRL+P in Cities Across India</h1>
          <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">Discover our printing services available at educational institutions throughout the country</p>
          
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {cities.map((city, index) => (
                <a href={city.link} key={index} className="group">
                  <div className="border-0 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer h-full bg-white transform hover:-translate-y-1">
                    <div className="h-44 bg-gray-200 relative overflow-hidden">
                      <img 
                        src={city.image} 
                        alt={`${city.name} City`} 
                        className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
                        onError={(e) => {
                          e.currentTarget.src = "https://via.placeholder.com/400x200?text=CTRL%2BP+Services";
                        }}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    </div>
                    <div className="p-5">
                      <h2 className="text-xl font-bold mb-2 text-gray-800">{city.name}</h2>
                      <p className="text-gray-700 leading-relaxed tracking-wide text-base">
                        {city.description}
                      </p>
                      <div className="mt-4 flex justify-end">
                        <span className="text-gray-600 font-medium flex items-center group-hover:text-gray-900">
                          View details
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
          
          {cities.length === 1 && (
            <div className="text-center mt-12 p-8 bg-white rounded-lg shadow-sm max-w-2xl mx-auto">
              <h3 className="text-2xl font-semibold mb-2">Coming to more cities soon</h3>
              <p className="text-gray-600 mb-4">We're expanding our services to more educational institutions across India.</p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CitiesPage;
